import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

const RegisteredRoute = ({ component: Component, ...rest }) => {
  const registered = useSelector(state => state.registered)

  return(
    <Route {...rest} render={props => (
      registered
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/' }} />
    )} />
  )
}

export default RegisteredRoute
